import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class PatientService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        let requestUrl = environment.apiUrl + 'patient/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash;
        // console.log(requestUrl)

        return this.http.get(requestUrl).map( (res: any) => {
            // console.log('solicitud a API: ' + JSON.stringify(res));
            return res;
        });
    }

    add(branch){
        let requestUrl = environment.apiUrl + 'patient/store';
        // console.log(JSON.stringify(branch));

        return this.http.post(requestUrl, branch).map( (res: any) => {
            // console.log(JSON.stringify(res));
            return res;
        });
    }

    edit(branch){
        let requestUrl = environment.apiUrl + 'patient/update/' + branch.id;

        return this.http.put(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    dashboard(req){
        req.count = req.count;

        let requestUrl = environment.apiUrl + 'patient/dashboard';
        requestUrl += "?count=" + req.count;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'patient/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    restore(id){
        let requestUrl = environment.apiUrl + 'patient/restore/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id, forceDelete){
        let requestUrl = environment.apiUrl + 'patient/delete/' + id;
        if(forceDelete){
            requestUrl += '?forceDelete=1';
        }
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/patient.service.ts